<template>
  <div v-if="deferrableCombos && deferrableCombos.length > 0">
    <h5>
      <b>{{ $t('specialPromos') }}</b>
    </h5>
    <div>{{ $t('youCanUsePromos') }}</div>
    <div v-for="promo in deferrableCombos" :key="promo.id" class="d-flex justify-content-between">
      <WCCheckbox
        :value="true"
        :model="!promo.deferred"
        @change="$emit('defer', { id: promo.id, defer: !promo.deferred })"
      />
      <div>
        <div class="d-flex justify-content-between">
          <span>{{ promo.name }}</span>
          <span>{{ $t('expirationAbbr') }} {{ promo.periodExpiration }}</span>
        </div>
        <div class="small">
          {{ $t('youCanUse') }} {{ promo.name }} {{ promo.uses }} {{ $t('moreTimes') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';

export default {
  name: 'WCSpecialPromos',
  components: { WCCheckbox },
  props: {
    deferrableCombos: {
      type: Array,
    },
  },
};
</script>
